import * as React from 'react';
import { Tag } from 'antd';
import { MasterConfigs } from '../../interfaces/entity';
import moment from 'moment';
import Badge from '../../components/Badge';

const projectConfigs: MasterConfigs = {
  api: () => '/projects',
  title: 'Project',
  isActionTab: true,
  maskClosable: false,
  modalTitle: (action) => action + ' Project',
  getColumns: () => {
    return [
      {
        title: 'Project Name',
        dataIndex: 'name',
        key: 'name',
        isSearch: true,
      },
      {
        title: 'Project Link',
        dataIndex: 'projectLink',
        key: 'projectLink',
      },
      {
        title: 'Starting Date',
        dataIndex: 'startDate',
        key: 'startDate',
        render: (text) => text ? <span>{moment(text).format('LL')}</span> : 'N/A'
      },
      {
        title: 'Status',
        dataIndex: 'projectStatus',
        key: 'projectStatus',
        align: 'center',
        isSearch: true,
        render: (projectStatus) => {
          if (projectStatus == 'HOLD') {
            return <Badge color="red" text="Hold" />;
          } else if (projectStatus == 'ACTIVE') {
            return <Badge color="green" text="Active" />;
          } else if (projectStatus == 'BLOKER') {
            return <Badge color="red" text="Bloker" />;
          } else if (projectStatus == 'COMPLETED') {
            return <Badge color="green" text="Completed" />;
          } else {
            return <Badge color="red" text="Not Started" />;
          }
        }
      },
    ];
  },
  rowSelection: {
    type: 'checkbox',
    ...{
      onChange: (selectedRowKeys: React.Key[], selectedRows) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      getCheckboxProps: (record) => ({
        name: record._id,
      }),
    }
  },
  getFormColumns: () => {
    return [
      {
        label: 'Project Name',
        name: 'name',
        type: 'text',
        rules: [{
          required: true,
          message: 'Project name is required'
        }]
      },
      {
        label: 'Starting Date',
        name: 'startDate',
        type: 'date',
      },
      {
        label: 'End Date',
        name: 'endDate',
        type: 'date',
      },
      {
        label: 'Project Type',
        name: 'projectType',
        type: 'select',
        children: [
          { value: 'FIXED_BID', name: 'Fixed Bid' },
          { value: 'HOURLY', name: 'Hourly' },
          { value: 'MONTHLY', name: 'Monthly' },
        ],
      },
      {
        label: 'Project Discriptions',
        name: 'description',
        type: 'textarea',
      },
      {
        label: 'Project Link',
        name: 'projectLink',
        type: 'url',
      },
      {
        label: 'Project Status',
        name: 'projectStatus',
        type: 'select',
        children: [
          { value: 'NOT_STARTED', name: 'Not Started' },
          { value: 'ACTIVE', name: 'Active' },
          { value: 'BLOKER', name: 'Bloker' },
          { value: 'COMPLETED', name: 'Completed' },
          { value: 'HOLD', name: 'Hold' },
        ],
      },
    ];
  },
  combo: [],
  getData: () => ({}),
  actions: [
    { name: 'Add Project', actionType: 'Add' },
    { name: 'Return', actionType: 'Back' },
  ],
};

export default projectConfigs;
